
import { useState, useEffect, useCallback } from "react";
import * as contatoService from "../services/contato.service";
import type { ContatoProjeto } from "../services/contato.service";

export function useContatosProjeto(projetoId: string | undefined) {
  const [contatos, setContatos] = useState<ContatoProjeto[]>([]);
  const [loading, setLoading] = useState(false);

  const buscar = useCallback(async () => {
    if (!projetoId) return;
    setLoading(true);
    try {
      const data = await contatoService.listarContatos(projetoId);
      setContatos(data);
    } catch {
      setContatos([]);
    } finally {
      setLoading(false);
    }
  }, [projetoId]);

  useEffect(() => {
    buscar();
  }, [buscar]);

  return { contatos, loading, recarregar: buscar };
}
